import React from 'react'
import * as RadixDialog from '@radix-ui/react-dialog'
import IconX from '@/components/IconX'

interface DialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  title?: string
}

const Dialog: React.FC<DialogProps> = ({
  isOpen,
  onOpenChange,
  children,
  title
}) => {
  return (
    <RadixDialog.Root
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-50 bg-gray-500/75 backdrop-blur-sm transition-all duration-200 ease-in-out" />
        <RadixDialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-4xl -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white p-4 shadow-md transition-all duration-200 ease-in-out">
          <div className="relative">
            <RadixDialog.Close className="absolute -right-12 -top-12 flex size-8 items-center justify-center rounded-full bg-white">
              <IconX className="size-6" />
            </RadixDialog.Close>
            {title && (
              <RadixDialog.Title className="mb-4 text-xl font-semibold">
                {title}
              </RadixDialog.Title>
            )}
            {children}
          </div>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}

export default Dialog
